<template>
  <v-card class="elevation-0 mt-n2 size-card">
    <v-card-title>
    <v-layout row grap >
      <v-row class="header">
        <v-col cols="10" sm="7" md="9">
          <confirm-dialog :confirmDialog="confirmDialog" :message="dialogMessage" @confirm="dialogConfirmAction" @cancel="cancelDialog" />
          <p class="title-users mt-2">{{$t('users')}}</p>
        </v-col>
        <v-col cols="10" sm="5" md="3">
          <v-row class="search-users">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                color="#2196F3"
                class="pa-0 ma-0 search-bar"
                background-color="#ededed"
                flat
                rounded
                clearable
                clear-icon="mdi-close-circle-outline"
              ></v-text-field>
          </v-row>
        </v-col>
      </v-row>
    </v-layout>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :item-key="key"
      :items="users"
      :search="search"
      mobile-breakpoint="1100"
      :footer-props="{
        'items-per-page-text':$t('usersPerPage'),
        'items-per-page-options': [5,10,15],
        'pageText': '{0}-{1} de {2}'
      }"  
      :header-props="{
        'sortByText': 'Ordenar Por'
      }"
      class="text-xs-right user-table"
      :no-data-text="$t('noData')"
      @page-count="pageCount = $event"
      :page.sync="page"
      :items-per-page="itemSelected"
      hide-default-footer
    >
    
    <template v-slot:[`item.username`]="{ item }">
      <v-col class="size-table pa-0">
        {{item.username}}
      </v-col>
    </template>
    <template v-slot:[`item.role`]="{ item }">
      <v-col class="size-table pa-0">
        {{roleTraduction(item.role)}}
      </v-col>
    </template>
    <template v-slot:[`item.firstname`]="{ item }">
      <v-col class="size-table pa-0">
        {{item.firstname}}
      </v-col>
    </template>
    <template v-slot:[`item.lastname`]="{ item }">
      <v-col class="size-table pa-0">
        {{item.lastname}}
      </v-col>
    </template>
    <template v-slot:[`item.email`]="{ item }">
      <v-col sm="10" class="size-table pa-0">
        {{item.email}}
      </v-col>
    </template>
    <template  v-slot:[`item.organism`]="{ item }">
      <v-col class="size-table pa-0">
        {{item.organism}}
      </v-col>
    </template>
      <template v-slot:[`item.actions`]="{ item }" >
                 
        <icon icon="mdi-qrcode-edit" @clicked="initResetQRProcess(item)" :name="$t('iconResetQr')" class="icon-size"/>          
        <icon v-if="item.emailConfirmed" icon="mdi-check" :name="$t('verifiedEmail')"/>
        <icon v-else icon="mdi-reload" @clicked="resendMail(item)" :disableIcon="item.emailConfirmed" :name="$t('iconMail')"/>          
        <icon icon="mdi-lock" :disableIcon="!item.emailConfirmed" @clicked="resetPassword(item)" :name="$t('iconResetPassword')"/>          
        <icon icon="mdi-pencil" @clicked="edit(item)" :name="$t('iconEdit')"/>
        <icon icon="mdi-delete" @clicked="initDeleteProcess(item)" :disableIcon="itsAme(item)" :name="$t('iconDelete')"/>
      </template>
      <template slot="footer">
        <div class="pt-2 pagination-table">
          <v-select
            :value="itemSelected"
            @change="itemSelected = parseInt($event, 10)"
            :items="itemsPerPage"
            class="select-items-page"
          ></v-select>
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="7"
            class="page"
            circle
          ></v-pagination>
          
        </div>
      </template>
      <template slot="no-results">
        <p>{{$t('noResults')}}</p>
      </template>
      
    </v-data-table>
    <v-layout>
      <v-row>
        <v-col cols="12" justify="end" align-self="end">
          <v-btn color="#5f98ed" dark rounded class="mr-4 mb-5 float-sm-right" @click.stop="createUser" >{{$t('createUser')}}</v-btn>
        </v-col>
      </v-row>
    </v-layout>
  </v-card>  
</template>

<script>
export default {
  components:{
    Icon: ()=> import('@/components/base/Icon'),
    ConfirmDialog: ()=> import('@/components/base/ConfirmDialog'),
  },
  data () {
    return {
      elem: '',
      key: '0',
      //search: '',
      headers: [
        {
          text: this.$t('username'),
          align: 'start',
          value: 'username'
        },
        {
          text: this.$t('role'),
          align: 'start',
          value: 'role',
          sortable: false
        },
        {
          text: this.$t('firstname'),
          align: 'start',
          value: 'firstname',
          sortable: false
        },
        {
          text: this.$t('lastname'),
          align: 'start',
          value: 'lastname',
          sortable: false
        },
        {
          text: this.$t('email'),
          align: 'start',
          value: 'email',
          sortable: false
        },
        {
          text: this.$t('organism'),
          align: 'start',
          value: 'organism',
          sortable: false
        },
        {
          text: this.$t('actions'),
          align: 'start',
          value: 'actions',
          sortable: false
        }      
      ],
      users: [],
      //userListInterval: 0,
      confirmDialog: false,
      dialogMessage: undefined,
      dialogConfirmAction: function(){},
      targetUser: undefined,
      pageCount: 0,
      itemSelected: 10,
      itemsPerPage: [5,10,15]

    }
  },
  computed : {
    search: {
      get() {
        return this.$store.getters.getSearch;
      },
      set(value) {
        return this.$store.commit("setSearch", value);
      },
    },
    makeRequest: {
      get(){
        return this.$store.getters.getMakeRequest
      }
    },
    page: {
      get(){
        return this.$store.getters.getPage
      },
      set(value){
        return this.$store.commit('setPage', value)
      }
    },
  },
  watch:{
    makeRequest: function(newVal, oldVal) {
      if(newVal !== oldVal){
        this.callData()
      }
    }
  },
  updated: function () {
    if (this.elem !== 'undefined'){
      this.elem = document.querySelectorAll("tr")
      this.elem.forEach( (e, index) =>{
        if ((index % 2) === 1) {
          e.classList.add('row-background-gray');
        }else{
          e.classList.add('row-background-white');
        }
      })  
    }
  },
  
  mounted(){
    /*var next = document.querySelector(".v-application--is-ltr .v-data-footer__icons-after .v-btn:first-child")
    var previous = document.querySelector(".v-application--is-ltr .v-data-footer__icons-before .v-btn:last-child")
    next.addEventListener("click", ()=>{this.key='next'})
    previous.addEventListener("click", ()=>{toString(this.key='previous')})*/
  },
  created(){
    this.callData()
    //this.userListInterval = setInterval(this.callData,60000)   
  },
  methods: {
    callData(){
      this.$extractions.getUsers().then(response=>{
        this.users = response.data
      }).catch(e=>{
        console.log('Error: ', e)
      })      
    },
    resetPassword(item){
      this.$emit('resetPassword',item.userId)
    },
    resetQr(item){
      this.$emit('resetQr',item.userId)
    },
    edit(item){
      this.$store.commit('setUserForEdition', item)
      this.$router.push("/users/update")
    },
    //delete process
    initDeleteProcess(item){
      this.targetUser = item
      this.confirmDialog = true
      this.dialogMessage = this.$t('messageDeleteUser')
      this.dialogConfirmAction = this.deleteItem
      
    },
    deleteItem(){
      this.$extractions.deleteUser(this.targetUser).then(()=>{
        this.$store.dispatch('snackAlert', true)
        this.targetUser = undefined
        this.callData()
      }).catch(err=>{
        this.$store.dispatch('snackAlert', false)
        console.log('error',err)
        this.targetUser = undefined
      })
      this.confirmDialog = false
    },
    //resetQRprocess
    initResetQRProcess(item){
      this.targetUser = item
      this.confirmDialog = true
      this.dialogMessage = this.$t('messageResetQr')
      this.dialogConfirmAction = this.resetQrCode
    },
    resetQrCode(){
      this.$extractions.resetQrCode(this.targetUser.username).then(()=>{
        this.$store.dispatch('snackAlert', true)
        this.targetUser = undefined
        this.confirmDialog = false
      }).catch(err=>{
        this.$store.dispatch('snackAlert', false)
        console.log('error',err)
        this.targetUser = undefined
      })
    },
    //cancelDialog
    cancelDialog(){
      this.confirmDialog = false
      this.targetUser = undefined
    },
    createUser(){
      this.$router.push("/users/create")
    },
    itsAme(item) {
      return (item.username === this.$store.getters.getUsername)
    },
    roleTraduction(role){
      return this.$t('roleType.' + role)
    },
    resendMail(item){
      this.$extractions.resendMail(item.userId).then((resp)=>{
        if(resp.data.success){
          this.$store.commit('setSnackText', this.$t('mail sent successfully'))
          this.$store.commit('setSnackBar', true)
        }
        else{
          this.$store.dispatch('snackAlert', false)  
        }
      }).catch(err=>{
        this.$store.dispatch('snackAlert', false)
        console.log('error',err)
      })
    },
  }
}
</script>
<style>
  
  .page{
    display: inline-block!important;
  }
  .page li{
    display: inline-block!important;
    vertical-align: middle!important;
  }
  .select-items-page{
    width: 50px!important;
    font-size: 12px!important;
    text-align: end!important;
    display: inline-block;
  }
  .pagination-table .v-pagination{
    
    max-width: 420px!important;
  }
  .pagination-table{
    text-align:end!important;
    margin-right:150px!important;
  }
  .page .v-pagination__item{
    box-shadow: none!important;
    font-size: 12px!important;
    font-weight: bold!important;
  }
  .page .v-pagination__navigation{
    box-shadow: none!important;
  }
  .page .v-pagination__item--active{
    color: #0d5ae5!important;
    background-color: #d3eafb!important;
  }
  .search-users{
    justify-content: flex-end!important;
    margin-right: 15px!important;
  }
  .search-bar{
    max-width: 320px!important;
  }
  .header{
    justify-content: space-between;
  }
   .v-text-field__slot{
    padding: 5px!important;
  }
  .v-input__append-inner{
    padding-top: 5px;
  }
  .search-bar .v-input .v-label {
    font-size: 12px!important;
    font-family: 'Epilogue', 'sans-serif';
    padding-top: 5px;
  }
  .dialog{
    overflow-x:hidden !important
  }
  .title-users{
    font-size:18px!important;
    font-family: 'Roboto', 'sans-serif';
    color: #0d5ae5;
  }
  .user-table{
    border: 1px solid #eee;
    border-radius: 18px;
    font-family: 'Open Sans', 'sans-serif';
    font-weight: 500;
    font-size: 14px;
  }
  .v-data-table th{
    border-bottom: none!important;
  }
  .v-data-table td{
    border-bottom: none!important;
  }
  .v-data-table tr:hover{
    color: #5f98ed!important;;
  }
  .row-background-gray{
    background-color: #f8faff!important;
  }
  .row-background-gray:hover{
    background-color: #f8faff!important;
  }
  .row-background-white{
    background-color: #fff!important;
  }
  .row-background-white:hover{
    background-color: #fff!important;
  }
  .size-card{
    padding: 0 40px!important;
  }
  @media (max-width: 1430px) {
    .size-table{
      font-size: 13px!important;
    }
    .v-data-table td{
      padding: 0 8px!important;
    }
    .icon-size{
      font-size: 20px!important;
    }
  }
  @media (max-width: 1120px) {
    .size-table{
      font-size: 12px!important;
    }
    .btn-size{
      width: 22px!important;
    }
  }
  @media (max-width: 1100px) {
    .size-table{
      font-size: 15px!important;
      padding: 0!important;
    }
    .col-sm-10{
      max-width: 100%;
    }
    td:hover{
     background-color: rgb(248, 248, 248)!important;
    }
    .v-data-table tr:hover{
      color: #000!important;
    }
  }
  
  @media (max-width: 960px) {
    .btn-size{
      width: 22px!important;
    }
    .theme--light.v-data-table tbody tr:not(:last-child) td:last-child, .theme--light.v-data-table tbody tr:not(:last-child) th:last-child{
      border-bottom: 1px solid #ccc!important;
    }
  }

  @media (max-width: 680px) {
    .size-card{
      padding: 0!important;
    }
  }
  
  @media (max-width: 599px) {
    .size-table {
      font-size: 13px !important;
    }
    .size-card{
      padding: 8px!important;
    }
    .v-data-footer__pagination{
      margin: 2px!important;
    }
    .v-data-footer__select{
      width: 100%!important;
    }
  }
  @media (max-width: 400px) {
    .size-table {
      font-size: 11px !important;
    }
  }
  @media (max-width: 350px) {
    .size-table {
      font-size: 10px !important;
    }
    
  }
 
  
  
</style>